import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import UpdateModal from "./updateModal";
import RemoveLogo from "./removeLogoModal";
import PreviewModal from "./previewModal";
import { FaRegEdit } from "react-icons/fa";
import { AiOutlineDelete } from "react-icons/ai";
import Table from "../../../components/table";
import Loader from "../../../components/loader";
import {
  fetchCms,
  uploadCms,
  deleteCms,
  updateCms,
  API_BASE_URL,
} from "../../../api/endpoint";
import axios from "axios";
import toast from "react-hot-toast";
import AddLogo from "./addLogoModal";

const Logos = () => {
  const [loading, setLoading] = useState(false);
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [logos, setLogos] = useState();
  const [selectedLogoType, setSelectedLogoType] = useState("");
  const [selectedLogoId, setSelectedLogoId] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [previewImg, setpreviewImg] = useState("");
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [preview, setPreview] = useState(false);
  const { auth } = useSelector((state) => state.login);

  useEffect(() => {
    fetchLogos();
  }, []);

  const fetchLogos = async () => {
    try {
      setLoading(true);
      const response = await axios.get(fetchCms, {
        params: { type: "LOGO" },
        headers: { Authorization: `Bearer ${auth}` },
      });
      const images = response?.data?.map((logo) => ({
        id: logo?.id,
        logoType: logo?.logoType,
        img: getImg(
          `${API_BASE_URL}public/images/${logo?.fileName}`,
          logo?.logoType
        ),
        actions: getActionButtons(logo?.id, logo?.logoType, `${API_BASE_URL}public/images/${logo?.fileName}`),
      }));
      setLogos(images);
    } catch (error) {
      // toast.error("Error fetching logos");
      console.error("Error fetching logos", error);
    } finally {
      setLoading(false);
    }
  };

  const uploadAndSaveImg = async (img, logoType, type) => {
    try {
      setLoading(true)
      const formData = new FormData();
      formData.append("file", img);

      const uploadResponse = await axios.post(uploadCms, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (uploadResponse.status === 200) {
        let fileName = uploadResponse.data.message;
        fileName = fileName?.split("/")?.pop();
        const payload = {
          fileName,
          imageType: "LOGO",
          logoType: logoType,
        };
        try {
          let response;
          if (type == "update") {
            response = await axios.post(updateCms, payload, {
              params: { id: selectedLogoId },
              headers: { Authorization: `Bearer ${auth}` },
            });
          } else {
            response = await axios.post(updateCms, payload, {
              headers: { Authorization: `Bearer ${auth}` },
            });
          }
          if (response.status === 200) {
            toast.success("Image saved successfully");
            fetchLogos();
          }
        } catch (error) {
          toast.error("Error saving image to DB");
          console.error("Error saving image to DB:", error);
        }
      }
    } catch (error) {
      toast.error("Error uploading image");
      console.error("Error uploading image:", error);
    } finally {
      setLoading(false)
    }
  };

  const deleteLogoCms = async () => {
    try {
      setLoading(true);
      const response = await axios.delete(deleteCms, {
        params: { id: selectedLogoId },
        headers: { Authorization: `Bearer ${auth}` },
      });
      if (response?.status == 200) {
        toast.success("Logo deleted");
        fetchLogos();
      }
    } catch (error) {
      toast.error("Error deleting logo");
      console.error("Error deleting logo", error);
    } finally {
      setLoading(false);
    }
  };

  const headings = [
    // { name: "ID", fieldName: "id", isSortable: false, sortKey: "none" },
    {
      name: "Logo Type",
      fieldName: "logoType",
      isSortable: false,
      sortKey: "none",
    },
    { name: "Image", fieldName: "img", isSortable: false, sortKey: "none" },
    {
      name: "Actions",
      fieldName: "actions",
      isSortable: false,
      sortKey: "none",
    },
  ];

  const getActionButtons = (id, logoType, imgUrl) => {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <button
          className="btn p-0 me-2"
          onClick={() => {
            setSelectedLogoId(id);
            setSelectedLogoType(logoType);
            setIsUpdateOpen(true);
            setImgUrl(imgUrl);
          }}
        >
          <FaRegEdit size={25} />
        </button>
        <button
          className="btn p-0"
          onClick={() => {
            setSelectedLogoId(id);
            setSelectedLogoType(logoType);
            setIsRemoveOpen(true);
            setImgUrl(imgUrl);
          }}
        >
          <AiOutlineDelete size={25} />
        </button>
      </div>
    );
  };

  const getImg = (src, type) => {
    return (
      <img
        src={src}
        style={{ height: "10rem", cursor: "pointer" }}
        onClick={() => {
          setSelectedLogoType(type);
          setpreviewImg(src);
          setPreview(true);
        }}
      />
    );
  };

  // const data = [
  //   {
  //     title: "Splash Screen",
  //     img: getImg("Splash Screen"),
  //     actions: () => getActionButtons("Splash Screen"),
  //   },
  //   {
  //     title: "App Icon",
  //     img: getImg("App Icon"),
  //     actions: () => getActionButtons("App Icon"),
  //   },
  //   {
  //     title: "Logo",
  //     img: getImg("Logo"),
  //     actions: () => getActionButtons("Logo"),
  //   },
  // ];

  return (
    <div>
      {/* <div className="d-flex justify-content-end mb-4">
        <Button text="+ Add Logo" callBack={() => setIsAddOpen(true)} />
      </div> */}
      <Table
        headings={headings}
        data={logos}
        enablePagination={false}
        addBtnText="+ Add Logo"
        addCallback={() => setIsAddOpen(true)}
        card={true}
      />
      <UpdateModal
        isUpdateOpen={isUpdateOpen}
        closeUpdateModal={() => setIsUpdateOpen(false)}
        selectedLogoType={selectedLogoType}
        uploadAndSaveImg={uploadAndSaveImg}
        selectedImgUrl={imgUrl}
      />
      <RemoveLogo
        isRemoveOpen={isRemoveOpen}
        closeRemoveModal={() => setIsRemoveOpen(false)}
        selectedLogoType={selectedLogoType}
        deleteLogoCms={deleteLogoCms}
        selectedImgUrl={imgUrl}
      />
      <PreviewModal
        preview={preview}
        closePreviewModal={() => setPreview(false)}
        previewImg={previewImg}
        selectedLogoType={selectedLogoType}
      />
      <AddLogo
        isAddMoreOpen={isAddOpen}
        closeAddMoreModal={() => setIsAddOpen(false)}
        uploadAndSaveImg={uploadAndSaveImg}
      />

      {loading && <Loader />}
    </div>
  );
};

export default Logos;
